import clsx from "clsx";

export default function TextInput(props){
    return (
        <input 
        {...props}
        className={clsx(
            "w-full bg-zoeil-grey px-[1.25rem] py-[1rem] text-[1.375rem] small-computer:text-large placeholder-black placeholder-opacity-60 outline-none",
            props.className
        )
        }
        onChange={(e)=>{
            if(props.changeHandler){
                props.changeHandler(e.target.value);
            }
        }}
        />
    )
}